import _ from 'lodash'

function getNotificationsToShow(
  assignments: Assignment[],
  visibleIds: string[],
): Assignment[] {
  // visibleIds = Set A
  const filteredAssignments = assignments.filter(
    assignment => assignment.scheduling,
  )
  const filteredAssignmentsIds = filteredAssignments.map(
    assignment => assignment.id,
  )

  // Set (A ∩ B)
  const intersectionOfFilteredAssignmentsIdsWithVisibleIds = _.intersection(
    visibleIds,
    filteredAssignmentsIds,
  )

  // Set A - (A ∩ B)
  const notificationIdsToShow = _.difference(
    filteredAssignmentsIds,
    intersectionOfFilteredAssignmentsIdsWithVisibleIds,
  )

  return filteredAssignments.filter(assignment =>
    notificationIdsToShow.includes(assignment.id),
  )
}

export { getNotificationsToShow }
